<template>
    <component v-if="data" :is="currentComponent" :umbracodata="data" />
</template>

<script>
import axios from "axios";

function setMetaTitle(title){
    document.title = title;
}
function setMetaDesc(desc){
    const tag = document.querySelector("[setmetadesc]");
    if(!tag)
    {
        tag = document.createElement('meta');
        document.head.appendChild(tag);
    }
    tag.setAttribute("name", "description");
    tag.setAttribute("content", desc);
    tag.setAttribute("setmetadesc","");
}
function setMetaKeywords(keywords){
    const tag = document.querySelector("[setmetakeywords]");
    if(!tag){
        tag = document.createElement('meta');
        document.head.appendChild(tag);
    }
    tag.setAttribute("name", "keywords");
    tag.setAttribute("content", keywords);
    tag.setAttribute("setmetakeywords","");
}
function setCanonicalUrl(to){
    // console.log("to", to);
    const tag = document.querySelector("[setCanonicalUrl]");
    tag.setAttribute("rel", "canonical");
    var url = "https://www.skovgaardvine.dk" + to.path;
    tag.setAttribute("href", url);
    tag.setAttribute("setCanonicalUrl","");
}

export default {
    computed: {
        currentComponent(){
            switch(this.data.contentType)
            {
                case "menuItem":
                    return () => import(/* webpackChunkName: "viewMenuItem" */ './views/menuitem.vue');
                case "product":
                    return () => import(/* webpackChunkName: "viewProduct" */ './views/product.vue');
                case "indholdsside":
                    return () => import(/* webpackChunkName: "viewIndhold" */ './views/indhold.vue');
                case "notFound":
                    return () => import(/* webpackChunkName: "viewNotFound" */ './views/notFound.vue');
                default :
                    // return () => this.$mq == "xs" || this.$mq == "sm" ?
                    return () => this.$mq == "xs" ? //&& document.location.href.indexOf("?mobile")>0 ?
                        import(/* webpackChunkName: "viewFrontpageMobile" */ './views/frontpage.mobile.vue'):
                        import(/* webpackChunkName: "viewFrontpage" */ './views/frontpage.vue');
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        if(window.parent)
            window.parent.postMessage("done:" + location.href, "*");
        var pageDataPromise = axios.get(window["baseUrl"] + to.path + "?altTemplate=pagedata");
        
        pageDataPromise.then((results)=>{
            setMetaTitle(results.data.metaTitle || (results.data.name + " - Skovgaard Vine"))
            setMetaDesc(results.data.metaDescription || results.data.metadescription || "");
            setMetaKeywords(results.data.metaKeywords || results.data.metakeywords || "");
            setCanonicalUrl(to);
            next(vm => {
                vm.setData(results.data);
                vm.$root.$emit('pagedata', results.data);
            });
        }, error => {
            if(error.response.status)
                next(vm => vm.setData({
                    contentType : "notFound"
                }));
        });
    },
    beforeRouteUpdate (to, from, next) {
        if(window.parent)
            window.parent.postMessage("done:" + location.href, "*");
        // this.data = null;
        axios.get(window["baseUrl"] + to.path + "?altTemplate=pagedata").then((res)=>{
            this.setData(res.data);
            this.$root.$emit('pagedata', res.data);
            // document.title = res.data.metaTitle || res.data.name;
            setMetaTitle(res.data.metaTitle || res.data.name + " - Skovgaard vine");
            setMetaDesc(res.data.metaDescription || res.data.metadescription || "");
            setMetaKeywords(res.data.metaKeywords || res.data.metakeywords || "");
            setCanonicalUrl(to);
            next()
        }, error => {
            if(error.response.status)
                next(vm => vm.setData({
                    contentType : "notFound"
                }));
        });
    },
    data(){
        return {
            data : null
        }
    },
    methods: {
        setData (data) {
            this.data = data;
        }
    }
}
</script>